export const MENU_BUTTON_HEIGHT = 48;